<template>
  <div class="row mb-3">
    <div class="col-7 col-md-12 col-lg-7">
      <div class="d-table h-100 w-100">
        <h6 class="text-light font-weight-normal mb-2 text-capitalize d-table-cell align-middle text-left text-md-center text-lg-left">
          <span v-if="type == 'months'">
            Age in Months
          </span>
          <span v-if="type == 'weeks'">
            Age in Weeks
          </span>
          <span v-if="type == 'days'">
            Age in Days
          </span>
        </h6>
      </div>
    </div>
    <div class="col-5 col-md-12 col-lg-5">
      <div class="d-table h-100 w-100 text-right">
        <h5 class="text-medium font-weight-bold text-center d-table-cell align-middle text-uppercase">
          {{ ageTime }}
        </h5>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";

export default {
  props: {
    type: { type: String, default: "months" },
    date: { type: String, required: true },
  },
  computed: {
    ageTime() {
      const a = dayjs();
      const b = dayjs(this.date);
      return a.diff(b, this.type);
    },
  },
};
</script>
